/**
 * Do not edit manually.
 * Frism Crm App API
 * OpenAPI spec version: v1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey,
} from '@tanstack/react-query';
import type {
  TermsResDtoApiResult,
  GetApiTermsParams,
  TermsKindResDtoApiResult,
} from '../../model';
import { customAxios } from '../../mutator/customAxios';
import type { ErrorType } from '../../mutator/customAxios';

/**
 * @summary 이용약관 조회
 */
export const getApiTerms = (
  params?: GetApiTermsParams,
  signal?: AbortSignal,
) => {
  return customAxios<TermsResDtoApiResult>({
    url: `/api/terms`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetApiTermsQueryKey = (params?: GetApiTermsParams) => [
  `/api/terms`,
  ...(params ? [params] : []),
];

export type GetApiTermsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTerms>>
>;
export type GetApiTermsQueryError = ErrorType<unknown>;

export const useGetApiTerms = <
  TData = Awaited<ReturnType<typeof getApiTerms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetApiTermsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiTerms>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTermsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTerms>>> = ({
    signal,
  }) => getApiTerms(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getApiTerms>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * @summary 이용약관 목록 조회 - 회원가입용
 */
export const getApiTermsListSignUp = (signal?: AbortSignal) => {
  return customAxios<TermsKindResDtoApiResult>({
    url: `/api/terms/list/sign-up`,
    method: 'get',
    signal,
  });
};

export const getGetApiTermsListSignUpQueryKey = () => [
  `/api/terms/list/sign-up`,
];

export type GetApiTermsListSignUpQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTermsListSignUp>>
>;
export type GetApiTermsListSignUpQueryError = ErrorType<unknown>;

export const useGetApiTermsListSignUp = <
  TData = Awaited<ReturnType<typeof getApiTermsListSignUp>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiTermsListSignUp>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTermsListSignUpQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTermsListSignUp>>
  > = ({ signal }) => getApiTermsListSignUp(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getApiTermsListSignUp>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * @summary 이용약관 목록 조회 - 로그인용
 */
export const getApiTermsListSignIn = (signal?: AbortSignal) => {
  return customAxios<TermsKindResDtoApiResult>({
    url: `/api/terms/list/sign-in`,
    method: 'get',
    signal,
  });
};

export const getGetApiTermsListSignInQueryKey = () => [
  `/api/terms/list/sign-in`,
];

export type GetApiTermsListSignInQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTermsListSignIn>>
>;
export type GetApiTermsListSignInQueryError = ErrorType<unknown>;

export const useGetApiTermsListSignIn = <
  TData = Awaited<ReturnType<typeof getApiTermsListSignIn>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiTermsListSignIn>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTermsListSignInQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTermsListSignIn>>
  > = ({ signal }) => getApiTermsListSignIn(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getApiTermsListSignIn>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};
